// Prevent closing from click inside dropdown
$(document).on('click', '.dropdown-menu', function (e) {
	e.stopPropagation();
});

function extraUrlCondition() {

	const disableLink = $('#primary-menu .menu-item a[href*="#"]');
	const disabledForClick = disableLink.closest('li');

	disabledForClick.addClass("disabled");

	const elForClick = $('.el-for-click');

	$(elForClick).on('click', function (event) {
		event.preventDefault();

		$(this).toggleClass('active');
		$(this).parent().siblings('.dropdown-menu').toggleClass('show');
	});

}

extraUrlCondition();

$('.navbar-toggler').click(function () {
	let previousScrollY = 0;

	if (!$('#primaryNavBar').hasClass('show')) {
		$('.navbar-toggler').addClass('close-menu');
		previousScrollY = window.scrollY;
		$('html').css({
			marginTop: -previousScrollY,
			overflow: 'hidden',
			left: 0,
			right: 0,
			top: 0,
			bottom: 0,
		});
		window.scrollTo(0, previousScrollY);
	} else {
		$('.navbar-toggler').removeClass('close-menu');
		$('html').css({
			marginTop: 0,
			overflow: 'visible',
			left: 'auto',
			right: 'auto',
			top: 'auto',
			bottom: 'auto',
			position: 'static',
		});
		window.scrollTo(0, previousScrollY);
	}
});


$(window).resize(function () {
	const win = $(this);
	if (win.width() >= 992) {
		$('#primaryNavBar').removeClass('show');
		$('.navbar-nav').find('.menu-item.show').removeClass('show');
		$('.dropdown-menu').removeClass('show').removeAttr('style');
		$('.el-for-click').removeClass('active');
		$('.navbar-toggler').removeClass('close-menu');
		$('html').css({
			marginTop: 0,
			overflow: 'visible',
			left: 'auto',
			right: 'auto',
			top: 'auto',
			bottom: 'auto',
			position: 'static',
		});
	}
});



// WEBPACK FOOTER //
// ./scripts/modules/_navbar.js